// src/locales/translationKeys.js

export const T_KEYS = {
  LIST_USER: {
    STATUS: {
      ACTIVE: "list_user.status.active",
      INACTIVE: "list_user.status.inactive",
    },
    USER: {
      RECORD: "list_user.user.record",
    },
    USERS: {
      RECORDS: "list_user.users.records",
    },
    VALIDATION: {
      PASSWORD: "da.reset.validation.password",
    },
    HEADING: "list_user.heading",
    CELL: {
      ROLES: "list_user.cell.roles",
    },
    LINK: {
      EDIT: "list_user.link.edit",
      RESET: "list_user.link.reset",
    },
    FILTER: {
      HEADING: "list_user.filter.heading",
      BUTTON: {
        RESET: "list_user.filter.button.reset",
        APPLY: "list_user.filter.button.apply",
      },
    },
    DATA: {
      ERROR: "list_user.data.error",
    },
  },

  MS: {
    BACK: "ms_back",
    RESET_PASSWORD: "ms_reset_password",
    RESET_PASSWORD_DIRECTION_MESSAGE: "ms_reset_password_direction_message",
    SEND: "ms_send",
    EMAIL: "ms_email",

    VALIDATION: {
      EMAIL: {
        INVALID: "ms.validation.email.invalid",
        REQUIRED: "ms.validation.email.required",
      },
      PASSWORD: {
        NOT_MATCH: "ms.validation.password.notmatch",
        SECURITY: "ms.validation.password.security",
      },
    },

    SET_PASSWORD: "ms_set_password",
    CHOOSE_PASSWORD: "ms_choose_password",
    NEW_PASSWORD: "ms_new_password",
    CONFIRM_PASSWORD: "ms_confirm_password",

    PASSWORD_RULES: {
      LENGTH: "ms_password_length",
      SPECIAL_CHAR: "ms_password_requirements",
      UPPERCASE: "ms_password_uppercase",
      LOWERCASE: "ms_password_lowercase",
      NUMBER: "ms_password_number",
    },

    SAVE_PASSWORD: "ms_save_password",

    PASSWORD_SENT: {
      HEADER: "ms.password.sent.header",
      BODY: "ms.password.send.body",
      BODY2: "ms.password.send.body2",
      RESEND: "ms.password.send.resend",
    },

    BACK_LOGIN_BUTTON: "ms.backlogin.button",

    WELL_DONE: {
      HEADER: "ms.welldone.header",
      BODY: "ms.welldone.body",
    },

    LOGIN_BUTTON: "ms.login.button",

    LINK_EXPIRED: {
      TITLE: "ms.link.expired.title",
      HEADER: "ms.link.expired.header",
      REPORT: {
        URL: "ms.link.expired.report.url",
        TEXT: "ms.link.expired.report.text",
      },
    },
  },
  PASSWORD_COOKIE_MISSING_OR_EXPIRED: "password.validation.auth_cookie_missing_or_expired",

  DA: {
    FORGOT: {
      TITLE: "da.forgot.title",
      SUBTITLE: "da.forgot.subtitle",
      LABEL: {
        EMAIL: "da.forgot.label.email",
      },
      BUTTON: {
        CONTINUE: "da.forgot.button.continue",
      },
      VALIDATION: {
        EMAIL: "da.forgot.validation.email",
      },
      PRIVACY: {
        PREFIX: "da.forgot.privacy.prefix",
        LINK: "da.forgot.privacy.link",
      },
    },

    RESET: {
      TITLE: "da.reset.title",
    },

    PASSWORD: {
      SUBTITLE: "da.password.subtitle",
      LABEL: {
        PASSWORD: "da.password.label.password",
      },

      REQ: {
        LENGTH: "da.password.req.length",
        NUMBER: "da.password.req.number",
        SPECIAL: "da.password.req.special",
        CASE: "da.password.req.case",
        STATUS: {
          MET: "da.password.req.status.met",
          NOT_MET: "da.password.req.status.not_met",
        },
      },
      VALIDATION: {
        PASSWORD: "da.password.validation.password",
        PASSWORD_REUSE: "da.password.validation.reuse",
      },
      BUTTON: {
        CONTINUE: "da.password.button.continue",
      },
    },

    RESET_LINK: {
      TITLE: "da.resetlink.title",
      SUBTITLE: "da.resetlink.subtitle",
      DESCRIPTION: {
        PREFIX: "da.resetlink.description.prefix",
      },
      FOOTER: {
        PREFIX: "da.resetlink.footer.prefix",
        LINK: "da.resetlink.footer.link",
      },
      BUTTON: {
        CONTINUE: "da.resetlink.button.continue",
      },
    },

    CHECK_EMAIL: {
      TITLE: "da.checkemail.title",
      DESCRIPTION: {
        PREFIX: "da.checkemail.description.prefix",
        LINK: "da.checkemail.description.link",
      },
      FOOTER: {
        PREFIX: "da.checkemail.footer.prefix",
        LINK: "da.checkemail.footer.link",
      },
    },

    LINK_EXPIRED: {
      BUTTON: {
        OPENMAIL: "da.linkexpired.button.openmail",
      },
      FOOTER: "da.linkexpired.footer",
    },

    BUTTON: {
      SIGNIN: "da.button.signin",
    },

    SAVED: {
      TITLE: "da.saved.title",
      DESCRIPTION: "da.saved.description",
    },

    SHELL: {
      COPYRIGHT: "da.shell.copyright",
      PRIVACY: "da.shell.privacy",
      TERMS: "da.shell.terms",
      TERMSLINK: "da.shell.termslink",
      PRIVACYLINK: "da.shell.privacylink",
      TERMSProdLINK: "da.shell.termsProdlink",
      PRIVACYProdLINK: "da.shell.privacyProdlink",
      SKIP_TO_MAIN: "da.shell.skiptomain",
    },
  },
};
